<template>
  <div class="hello">
    <Header></Header>

      <div class="listsearch">

        <div class="kx-date">
           <em>快讯</em>
           <span class="left-arrow"></span>
             {{nowTime}}
        </div>

        <el-row>
          <div v-for="(o, index) in RealtimeArtical" :key="index">
            <el-col  v-if="o.origin != undefined">
              <div class="kx-item">
                <h2>{{o.article_name}}</h2>
                <p class="time">时间:{{o.time}}</p>
                <p>{{o.article_content}}({{ o.origin }})</p>
              </div>
            </el-col>
  
            <el-col  v-else>
              <div class="kx-item">
                <h2>{{o.title}}</h2>
                <p class="time">时间:{{o.time}}</p>
                <p>{{o.content}}</p>
              </div>
            </el-col>
          </div>
         

        </el-row>


    </div>



    <bbottom></bbottom>

  </div>

</template>
<script>

  import Header from "@/components/public/Header.vue"
  import bbottom from "@/components/public/bbottom.vue"
  export default {
    name: 'Searchresult',

    data() {
     return {
        nowTime:'',
        RealtimeArtical:[],
     }
    },

    created(){
        this.timeFormate(new Date())
        this.getRealtimeArtical()
    },
    //页面加载后执行方法
    methods: {

         //显示当前时间（年月日时分秒）
        timeFormate(timeStamp) {
        let year = new Date(timeStamp).getFullYear();
        let month =new Date(timeStamp).getMonth() + 1 < 10? "0" + (new Date(timeStamp).getMonth() + 1): new Date(timeStamp).getMonth() + 1;
        let date =new Date(timeStamp).getDate() < 10? "0" + new Date(timeStamp).getDate(): new Date(timeStamp).getDate();
        let hh =new Date(timeStamp).getHours() < 10? "0" + new Date(timeStamp).getHours(): new Date(timeStamp).getHours();
        let week = new Date(timeStamp).getDay();
        let weeks = ["日","一","二","三","四","五","六"];
        let getWeek = "星期" + weeks[week];
        this.nowTime = year + "年" + month + "月" + date +"日"+" "+getWeek;
        },

        getRealtimeArtical(){
            var config = {
          method: 'GET',
          url: '/api/v1/realtimedata/list',
          headers: { 
              'Content-Type': 'application/json'
          }
        };
            
        this.$axios(config).then(res=>{

          this.RealtimeArtical = res.data
          
        }).catch(error=>{
          console.log('请求失败')
        })
        }
    },
    //组件引入
    components: {

      Header,
      bbottom
    },
  }

</script>
<style scoped>

  .clearfix:before,
  .clearfix:after {
    display: table;
    content: "";
  }

  .clearfix:after {
    clear: both
  }

  .content_s {
    width: 1200px;
    margin: 25px auto;
    color: #4b4b4b;
  }



  .top {
    width: 1200px;
    margin: 0 auto;
  }

    .top img {
      display: block
    }

  .listsearch {
    width: 880px;
    padding: 20px;
    margin: 0 auto;
  }

    .listsearch .el-tabs__item {
      font-size: 20px !important;
    }
  .kx-item {
    width: 100%;
    padding: 25px;
    border: 1px solid #f1f1f1;
    border-radius: 6px;
    margin: 10px auto;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    cursor: pointer;
  }
    .kx-item:hover {
      border: 1px solid #bd0c16;
    }
    .kx-item h3 {
      margin: 0px;
      padding: 0px 0px 10px;
      font-size: 20px;
      line-height: 28px;
    }

    .listsearch a {
      color: #4b4b4b;
      text-decoration: none;
    }

      .listsearch a:hover h3 {
        color: #bd0c16;
      }
  .kx-item p {
    font-size: 16px;
    line-height: 24px;
    margin: 0px;
    padding: 0px;
  }

  .kx-item span {
    margin: 0px;
    padding: 10px 0px 0px;
    font-size: 12px;
    line-height: 18px;
    color: #999;
    display: block;
  }

  .kx-item em {
    font-weight: bold;
    font-style: normal;
    color: #bd0c16;
  }

  .listsearch-nodata {
    width: 830px;
    padding: 40px 25px;
    -webkit-box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
    text-align: center;
    font-size: 16px;
    line-height: 24px;
  }
  .kx-item h2 {
    font-size: 16px;
    line-height: 24px;
    margin: 0px 0 4px;
    font-weight: 600;
    color:#4b4b4b;
  }
 
  .kx-item  p {
    margin: 0;
    padding: 0;
    font-size: 14px;
    line-height: 24px;
  }
    .kx-item  p.time {
      color: #bd0c16;
    }
  .kx-date {
    background: #f1f1f1;
    height: 50px;
    line-height: 50px;
    color: #4b4b4b;
    font-size: 16px;
    font-weight: 700;
    text-indent: 15px;
    text-align:center;
  }
    .kx-date em{
      font-style: normal;
      color: #bd0c16;
    }
  .left-arrow{
    display: inline-block;
    width: 0;
    height: 0;
    border-top: 9px solid #bd0c16;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    margin: 0 4px;
  }
</style>



// WEBPACK FOOTER //
// src/components/RealList.vue